<template>
  <div class="tutor">
    <div class="search">
      <div class="oveAuto">
        <div class="sTitle sItem">高级搜索</div>
        <el-popover
          placement="right"
          width="400"
          trigger="click"
          v-model="visible1"
        >
          <div class="searchItem">
            <el-input
              v-model="xm"
              placeholder="请输入搜索姓名"
              style="margin-right: 10px"
            ></el-input>
            <el-button type="primary" @click="searName">确定</el-button>
          </div>
          <div class="sItem" slot="reference">
            <div>
              姓名
              <el-tag closable @close="closeName" v-if="cloName">{{
                queryPage.xm
              }}</el-tag>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-popover>
        <el-popover
          placement="right"
          width="400"
          trigger="click"
          v-model="visible2"
        >
          <div class="searchItem">
            <el-select
              v-model="dslx"
              placeholder="请选择导师类型"
              filterable
              style="width: 290px"
            >
              <el-option
                v-for="item in toturOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button type="primary" @click="tourLX">确定</el-button>
          </div>
          <div class="sItem" slot="reference">
            <div>
              导师类型
              <el-tag closable @close="closeLX" v-if="cloLX">{{
                show.dslx
              }}</el-tag>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-popover>
        <el-popover
          placement="right"
          width="400"
          trigger="click"
          v-model="visible3"
        >
          <div class="searchItem">
            <el-select
              v-model="xy"
              placeholder="请选择学院"
              filterable
              style="width: 290px"
            >
              <el-option
                v-for="item in xyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button type="primary" @click="tourXY">确定</el-button>
          </div>
          <div class="sItem" slot="reference">
            <div>
              学院
              <el-tag closable @close="closeXY" v-if="cloXY">{{
                show.xy
              }}</el-tag>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-popover>
        <el-popover
          placement="right"
          width="400"
          trigger="click"
          v-model="visible4"
        >
          <div class="searchItem">
            <el-select
              v-model="zy"
              placeholder="请选择指导二级学科"
              filterable
              style="width: 290px"
            >
              <el-option
                v-for="item in zyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button type="primary" @click="tourZD">确定</el-button>
          </div>
          <div class="sItem" slot="reference">
            <div>
              指导二级学科
              <el-tag closable @close="closeZD" v-if="cloZD">{{
                show.zy
              }}</el-tag>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-popover>
        <el-popover
          placement="right"
          width="400"
          trigger="click"
          v-model="visible5"
        >
          <div class="searchItem">
            <el-input
              v-model="grxx"
              placeholder="请输入搜索研究方向"
              style="margin-right: 10px"
            ></el-input>
            <el-button type="primary" @click="searDirec">确定</el-button>
          </div>
          <div class="sItem" slot="reference">
            <div>
              研究方向
              <el-tag closable @close="closeDirec" v-if="cloDirec">{{
                queryPage.grxx
              }}</el-tag>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- <div class="detailList" ref="container" @scroll="handleScroll"> -->
    <div class="detailList" ref="container">
      <div class="teacherList">
        <div class="teacher" v-for="(item, index) in formList" :key="index">
          <div @click="toDetail(item.gh)">
            <div class="teacherImg">
              <!-- <img :src="item.zp" alt="" v-if="item.zp" /> -->
              <el-image
                fit="contain"
                v-if="item.zp"
                :src="item.zp"
                class="img"
              ></el-image>
              <el-image
                fit="contain"
                :src="require('../../assets/toturImg/women.jpg')"
                v-else-if="item.xbm == 2"
                class="img"
              ></el-image>
              <el-image
                fit="contain"
                :src="require('../../assets/toturImg/man.jpg')"
                v-else-if="item.xbm == 1"
                class="img"
              ></el-image>
            </div>
            <div class="teacherInfo">
              <p class="name">
                {{ item.xm }}<span v-if="item.zc">(</span>{{ item.zc
                }}<span v-if="item.zc">)</span>
              </p>
              <!-- <p class="position">{{ item.zc }}</p> -->
              <p class="unit">{{ item.ssdw }}</p>
              <p class="unit" v-if="item.dslb == 1 || item.dslb == 3">
                博导二级学科:{{ item.bZymc }}
              </p>
              <p class="unit" v-if="item.dslb == 2 || item.dslb == 3">
                硕导二级学科:{{ item.cZymc }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="pageBgc">
        <div class="page">
          <span style="margin-left: 100px"
            >© 技术支持：杭州毕为科技有限公司</span
          >
          <el-pagination
            style="margin-bottom: 10px"
            :total="total"
            :page.sync="queryPage.pageNum"
            :limit.sync="queryPage.pageSize"
            :page-size="8"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            layout="total, prev, pager, next, jumper"
            class="pagination-content"
            @pagination="tableList"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div>
      <el-button
        v-show="isLoding"
        type="text"
        style="display: flex; margin: 0 0 0 60%; color: #000; font-size: 20px"
        ><i class="el-icon-loading"></i
      ></el-button>
    </div>
    <div v-if="noMore">
      <!-- <el-button
          type="text"
          v-show="finishLoding"
          style="display: flex; margin: 0 0 0 60%; color: #000;font-size:20px"
          >已经没有更多啦~</el-button
        > -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formList: [],
      queryPage: {
        pageNum: 1, // 当前页
        pageSize: 8, // 每页显示条数
        xm: "",
        dslx: "",
        xy: "",
        zy: "",
        grxx: "",
      },
      currentPage: 1,
      show: {
        dslx: "",
        xy: "",
        zy: "",
      },
      total: 0,
      xm: "",
      dslx: "",
      xy: "",
      zy: "",
      grxx: "",
      toturOptions: [],
      xyOptions: [],
      zyOptions: [],
      value: "",
      cloName: false,
      cloLX: false,
      cloXY: false,
      cloZD: false,
      cloDirec: false,
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      loading: true, // 组件loading的展示
      isLoding: false, // 加载中，loading图标
      finishLoding: false, // 加载完成，显示已经没有更多了
      noMore: false, // 搜索结果无的展示
    };
  },
  mounted() {
    //  window.addEventListener("scroll", this.throttle(this.handleScroll, 1000),true);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.throttle(), false);
  },
  methods: {
    // handleScroll(e){
    //      const clientHeight = e.target.clientHeight //可视区域
    //      const scrollHeight = e.target.scrollHeight  // 滚动文档高度
    //      const scrollTop =e.target.scrollTop //container.scrollTop  // 已滚动的高度

    //      console.log("container",clientHeight,scrollHeight,scrollTop,);
    //      console.log("aaa",scrollTop + clientHeight,scrollHeight);
    //       // console.log(" this.queryPage.pageNum ",  this.queryPage.pageNum );
    //         this.noMore=true
    //      if( scrollTop + clientHeight >= scrollHeight && scrollHeight!=0){

    //          console.log(this.formList.length,this.total);
    //          if (this.formList.length >= this.total) {
    //            console.log("xxxxxxxxx");
    //             this.isLoding = false;
    //            this.finishLoding = true;
    //           window.removeEventListener("scroll", this.throttle(), false);
    //         }else{
    //           console.log("cccccccccccccccc");
    //           this.queryPage.pageNum=this.queryPage.pageNum+1
    //           this.loadList()
    //         }

    //      }else{
    //        console.log("llllllllllllllll");
    //        window.removeEventListener("scroll", this.throttle(), false);
    //        return false
    //      }
    // },
    //  throttle(fn, wait) {
    //     // 封装函数进行节流
    //     var timer = null;
    //     return function () {
    //       var context = this;
    //       var args = arguments;
    //       if (!timer) {
    //         timer = setTimeout(function () {
    //           fn.apply(context, args);
    //           timer = null;
    //         }, wait);
    //       }
    //     };
    // },
    handleCurrentChange(val, a) {
      this.queryPage.pageNum = val;
      this.loadList();
    },
    handleSizeChange() {
      this.queryPage.pageNum = this.currentPage;
    },
    loadList() {
      // console.log("ggggggggggggggg");
      // this.loading = true
      this.isLoding = true;
      this.$http
        .post("/cultivate/mien/selectTutorMien", {
          ...this.queryPage,
        })
        .then((res) => {
          // console.log(" this.noMore ", this.noMore );
          let data = res.data.data;
          // const newData =data.list
          // if(this.noMore && this.queryPage.pageNum!=1){
          //触底加载
          //  this.formList = [...this.formList,...newData];
          // }else{
          //   //搜索加载
          //   // console.log("vvvvvvvvvvvvvvvvv");
          this.formList = data.list;
          //  this.queryPage.pageNum=1
          // }
          this.isLoding = false;
          //  this.noMore = false;
          console.log(" this.formList", this.formList);
          this.total = data.total;
          //  this.loading = false
          //  console.log("  this.queryPage.pageNum=1",  this.queryPage.pageNum);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 姓名
    searName() {
      this.queryPage.xm = this.xm;
      if (this.xm != "") {
        this.xm = "";
        this.cloName = true;
      }
      this.visible1 = !this.visible1;
      this.queryPage.pageNum = 1;
      this.currentPage = 1;
      this.noMore = false;
      this.loadList();
    },
    closeName() {
      this.queryPage.xm = "";
      this.loadList();
      this.noMore = false;
      this.cloName = false;
    },
    // 导师类型
    tourLX() {
      this.queryPage.dslx = this.dslx;
      if (this.dslx != "") {
        this.dslx = "";
        this.cloLX = true;
      }
      this.queryPage.pageNum = 1;
      this.currentPage = 1;
      this.show.dslx = this.toturOptions.find((item) => {
        return item.value == this.queryPage.dslx;
      }).label;
      this.loadList();
      this.noMore = false;
      this.visible2 = !this.visible2;
    },
    closeLX() {
      this.queryPage.dslx = "";
      this.cloLX = false;
      this.loadList();
      this.noMore = false;
    },
    // 学院
    tourXY() {
      this.queryPage.xy = this.xy;
      this.queryPage.pageNum = 1;
      this.currentPage = 1;
      if (this.xy != "") {
        this.xy = "";
        this.cloXY = true;
      }
      this.show.xy = this.xyOptions.find((item) => {
        return item.value == this.queryPage.xy;
      }).label;
      this.loadList();
      this.noMore = false;
      this.visible3 = !this.visible3;
    },
    closeXY() {
      this.queryPage.xy = "";
      this.cloXY = false;
      this.loadList();
      this.noMore = false;
    },
    // 指导专业
    tourZD() {
      this.queryPage.zy = this.zy;
      this.queryPage.pageNum = 1;
      this.currentPage = 1;
      if (this.zy != "") {
        this.zy = "";
        this.cloZD = true;
      }
      this.show.zy = this.zyOptions.find((item) => {
        return item.value == this.queryPage.zy;
      }).label;
      this.loadList();
      this.noMore = false;
      this.visible4 = !this.visible4;
    },
    closeZD() {
      this.queryPage.zy = "";
      this.cloZD = false;
      this.loadList();
      this.noMore = false;
    },
    // 研究方向
    searDirec() {
      this.queryPage.grxx = this.grxx;
      this.queryPage.pageNum = 1;
      if (this.grxx != "") {
        this.grxx = "";
        this.cloDirec = true;
      }
      this.loadList();
      this.noMore = false;
      this.visible5 = !this.visible5;
    },
    closeDirec() {
      this.queryPage.grxx = "";
      this.loadList();
      this.noMore = false;
      this.cloDirec = false;
    },
    tableList() {
      this.loadList();
    },
    toDetail(gh) {
      // this.$router.push({ path: "/briefIntroduction", query: { gh: gh } });
      let url = `/push/briefIntroduction?gh=${gh}`; // 构建带有查询参数的 URL
      window.open(url, "_blank"); // 在新标签页中打开 URL
    },
    getTotur() {
      this.$http
        .get("/cultivate/teacher/selectZdccList")
        .then((res) => {
          let data = res.data.data;
          this.toturOptions = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getXY() {
      this.$http
        .get(`/cultivate/mien/selectCollege`)
        .then((res) => {
          let data = res.data.data;
          this.xyOptions = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getZY() {
      this.$http
        .get(`/cultivate/mien/selectTutorMajorList`)
        .then((res) => {
          let data = res.data.data;
          this.zyOptions = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.loadList();
    this.getTotur();
    this.getXY();
    this.getZY();
  },
};
</script>
<style lang="scss">
.el-pagination__total,
.el-pagination__jump,
.el-pagination button:disabled,
.el-pager li,
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev,
.el-pagination .btn-prev,
.el-pagination .btn-next {
  background-color: #4166af; /*进行修改未选中背景和字体 */
  color: #fff;
}
.el-pagination.is-background .el-pagerli:not(.disabled) {
  background-color: #4166af; /*进行修改未选中背景和字体 */
  color: #fff;
}
.el-pagination.is-background.el-pagerli:not(.disabled).active  {
  background-color: #4166af; /*进行修改选中项背景和字体 */
  color: #fff;
}
</style>
<style scoped lang="scss">
.tutor {
  width: 100%;
  // height: 100vh;
  font-size: 14px;
  // display: flex;
  // justify-content: space-between;
  // border: 1px solid red;
  position: relative;
  .search {
    width: 400px;
    height: 700px;
    position: fixed;
    // top: 15%;
    // left: 12%;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    .oveAuto {
      overflow: auto;
      width: 100%;
      height: 100%;
      padding: 20px 20px;
    }
    .sTitle {
      font-size: 30px;
      justify-content: center !important;
      font-weight: bold !important;
    }
    .sItem {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
      line-height: 70px;
      color: #4166af;
      border-bottom: 1px solid #cfcfcf;
      i {
        color: #ccc;
        line-height: 70px;
      }
    }
  }
  .detailList {
    // border: 4px solid rgb(108, 46, 190);
    min-width: 1265px;
    height: 700px;
    overflow: hidden;
    overflow-y: scroll;
    box-sizing: border-box;
    position: relative;
    margin-left: 460px;
    .teacherList {
      display: flex;
      flex-wrap: wrap;
      // height: 700px;
      width: 1265px;

      .teacher {
        width: 300px;
        height: 340px;
        background: rgba(255, 255, 255, 0.39);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        margin-right: 10px;
        margin-bottom: 20px;
        opacity: 1;
        cursor: pointer;
      }
    }
  }
}

.pageBgc {
  bottom: 0;
  background: #4166af;
  position: fixed;
  left: 0;
  width: 100vw;
  height: 75px;
  padding-top: 15px;
}
.page {
  background: #4166af !important;
  color: #fff !important;
  min-width: 320px;
  padding: 0 10px;
  text-align: center;
  position: absolute;
  left: calc(50% - 250px);
}

.teacherImg {
  width: 100%;
  background: #fff;
  height: 210px;
  text-align: center;
  overflow: hidden;
  // border: 1px solid red;
  padding-top: 20px;
  .img {
    width: 80%;
    height: 200px;
  }
}
.teacherInfo {
  height: 140px;
  background: #4166af;
  text-align: center;
  //  border: 1px solid red;
  color: #fff;
  padding: 10px 0 10px 0;
  .name {
    font-size: 24px;
  }
  .position {
    font-size: 14px;
    margin: 10px 0;
    min-height: 18px;
  }
  .unit {
    font-size: 14px;
    margin: 10px 0;
    // padding-bottom: 10px;
  }
}
.lxItem {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  color: #4166af;
  border-bottom: 1px solid #cfcfcf;
  margin-left: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.searchItem {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 1300px) {
  .tutor {
    height: 100%;
  }
  .teacherImg {
    width: 100% /* 100/16 */ !important;
    background: #fff;
    height: 100px /* 100/16 */ /* 210/16 */ !important;
    text-align: center;
    overflow: hidden;
    padding-top: 1.25rem /* 20/16 */ !important;
    .img {
      width: 100% /* 100/16 */ !important;
      height: 95% !important;
    }
  }
  .search {
    width: 20rem /* 400/16 */ !important;
    height: calc(100% - 200px) !important;
    position: fixed;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    .oveAuto {
      // overflow: auto;
      width: 100%;
      height: 100%;
      padding: 1.25rem /* 20/16 */ 1.25rem !important;
    }
    .sTitle {
      font-size: 1.125rem /* 18/16 */ /* 30/16 */ !important;
      justify-content: center !important;
      font-weight: bold !important;
    }
    .sItem {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      font-size: 1.125rem /* 18/16 */ /* 24/16 */ !important;
      line-height: 3.125rem /* 50/16 */ /* 70/16 */ !important;
      color: #4166af;
      border-bottom: 1px solid #cfcfcf;
      i {
        color: #ccc;
        line-height: 3.125rem /* 50/16 */ /* 70/16 */ !important;
      }
    }
  }
  .detailList {
    min-width: 60rem /* 1265/16 */ !important;
    height: 100% !important;
    // height: calc(100% - 200px) !important;

    // height: calc(100% - 4.6875rem /* 75/16 */) !important;
    font-size: 0.75rem /* 12/16 */ !important;
    overflow: hidden;
    overflow-y: hidden !important;
    box-sizing: border-box;
    position: relative;
    margin-left: 23.75rem /* 460/16 */ !important;
    .teacherList {
      display: flex;
      flex-wrap: wrap;

      width: 70rem /* 1265/16 */ !important;
      height: 100%;

      .teacher {
        width: 21% !important;
        height: 150px /* 200/16 */ /* 340/16 */ !important;
        background: rgba(255, 255, 255, 0.39);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        margin-right: 0.625rem /* 10/16 */ !important;
        margin-bottom: 1.25rem /* 20/16 */ !important;
        opacity: 1;
        cursor: pointer;
      }
    }
  }
  .teacherInfo {
    height: 88px /* 140/16 */ !important;
    background: #4166af;
    text-align: center;
    //  border: 1px solid red;
    color: #fff;
    padding: 0.625rem /* 10/16 */ 0 0.625rem 0 !important;
    .name {
      width: 100% !important;
      height: 15px /* 20/16 */ /* 35/16 */ !important;
      font-size: 10px !important; /* 14/16 */
    }
    .position {
      font-size: 10px /* 14/16 */ !important;
      margin: 5px 0 !important;
      min-height: 15px /* 18/16 */ !important;
    }
    .unit {
      height: 15px /* 20/16 */ /* 35/16 */ !important;
      // padding: 5px /* 5/16 */!important;
      font-size: 10px !important;
      margin: 0 !important;
    }
  }
}
@media screen and (min-width: 1301px) and (max-width: 1400px) {
  .tutor {
    height: 100%;
  }
  .teacherImg {
    width: 100% /* 100/16 */ !important;
    background: #fff;
    height: 100px /* 100/16 */ /* 210/16 */ !important;
    text-align: center;
    overflow: hidden;
    padding-top: 1.25rem /* 20/16 */ !important;
    .img {
      width: 100% /* 100/16 */ !important;
      height: 95% !important;
    }
  }
  .search {
    width: 20rem /* 400/16 */ !important;
    height: calc(100% - 216px) !important;
    position: fixed;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    .oveAuto {
      // overflow: auto;
      width: 100%;
      height: 100%;
      padding: 1.25rem /* 20/16 */ 1.25rem !important;
    }
    .sTitle {
      font-size: 1.125rem /* 18/16 */ /* 30/16 */ !important;
      justify-content: center !important;
      font-weight: bold !important;
    }
    .sItem {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      font-size: 1.125rem /* 18/16 */ /* 24/16 */ !important;
      line-height: 3.125rem /* 50/16 */ /* 70/16 */ !important;
      color: #4166af;
      border-bottom: 1px solid #cfcfcf;
      i {
        color: #ccc;
        line-height: 3.125rem /* 50/16 */ /* 70/16 */ !important;
      }
    }
  }
  .detailList {
    min-width: 60rem /* 1265/16 */ !important;
    height: 100% !important;
    // height: calc(100% - 200px) !important;

    // height: calc(100% - 4.6875rem /* 75/16 */) !important;
    font-size: 0.75rem /* 12/16 */ !important;
    overflow: hidden;
    overflow-y: hidden !important;
    box-sizing: border-box;
    position: relative;
    margin-left: 23.75rem /* 460/16 */ !important;
    .teacherList {
      display: flex;
      flex-wrap: wrap;

      width: 70rem /* 1265/16 */ !important;
      height: 100%;

      .teacher {
        width: 21% !important;
        height: 150px /* 200/16 */ /* 340/16 */ !important;
        background: rgba(255, 255, 255, 0.39);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        margin-right: 0.625rem /* 10/16 */ !important;
        margin-bottom: 1.25rem /* 20/16 */ !important;
        opacity: 1;
        cursor: pointer;
      }
    }
  }
  .teacherInfo {
    height: 88px /* 140/16 */ !important;
    background: #4166af;
    text-align: center;
    //  border: 1px solid red;
    color: #fff;
    padding: 0.625rem /* 10/16 */ 0 0.625rem 0 !important;
    .name {
      width: 100% !important;
      height: 15px /* 20/16 */ /* 35/16 */ !important;
      font-size: 10px !important; /* 14/16 */
    }
    .position {
      font-size: 10px /* 14/16 */ !important;
      margin: 5px 0 !important;
      min-height: 15px /* 18/16 */ !important;
    }
    .unit {
      height: 15px /* 20/16 */ /* 35/16 */ !important;
      // padding: 5px /* 5/16 */!important;
      font-size: 10px !important;
      margin: 0 !important;
    }
  }
}
</style>
